import http from '../utils/http'
// 人员列表
export function sysUserListAPI(data) {
    return http.post('/sysUser/list', data)
}
// 人员详情
export function sysUserDetailAPI(data) {
    return http.get('/sysUser/detail', data)
}
// 编辑人员
export function editSysUserAPI(data) {
    return http.post('/sysUser/edit', data)
}
// 添加人员
export function addSysUserAPI(data) {
    return http.post('/sysUser/add', data)
}
// 上传人员头像
export function uploaduserImageAPI(data) {
    return http.post('/sysUser/uploaduserimage', data)
}
// 删除人员
export function deleteSysUserAPI(data) {
    return http.post('/sysUser/delete', data)
}
// 编辑状态(锁定|解锁)
export function editStatusAPI(data) {
    return http.post('/sysUser/editstatus', data)
}